// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from './App'
import router from './router'
import app from '@/assets/js/common'
import { Lazyload } from 'vant';
import { Image as VanImage } from 'vant';
import { Picker } from 'vant';
import VueWechatTitle from "vue-wechat-title";
import echarts from 'echarts'

Vue.prototype.$echarts = echarts
Vue.use(VueWechatTitle);
// 注册时可以配置额外的选项
Vue.use(VanImage);
Vue.use(Picker);
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.config.productionTip = false;
Vue.prototype.app = app;
const ADD_COUNT = 'ADD_COUNT';//常量代替事件类型，是的代码更清晰
const REMOVE_COUNT = 'REMOVE_COUNT';
// 注册状态管理全局参数
var store = new Vuex.Store({
  state:{
    openid:'',//供应商
    title:''
  },
  mutations:{
    [ADD_COUNT] (state , openid ,){
      state.openid = localStorage.getItem('openid');
    },
    [REMOVE_COUNT] (state, openid ,){
      state.openid = localStorage.removeItem('openid');
    },
  }
});

router.beforeEach((to,from,next) =>{
  store.state.openid = localStorage.getItem('openid');
  localStorage.setItem('area_id','1');
  localStorage.setItem('area_name','东莞江西商会');
  if (to.meta.requireAuth) { //判断该路由是否需要登录权限
    if( store.state.openid == 'undefined' || store.state.openid == '' ){
      next({
        path: '/login',
        // query: {redirect: to.fullPath}
        //将跳转的路由path作为参数，登录成功后跳转到该页面
      });
    }
    if (store.state.openid !== '') { //通过vuex state 获取当前的openid 是否存储
      next();
    }
    if( store.state.openid == null ) {
      next({
        path: '/login',
        query:{ state: '0' },
        // query: {redirect: to.fullPath}
        //将跳转的路由path作为参数，登录成功后跳转到该页面

      });
    }
  }else{
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js